import React from "react";
import { QueryResult, FetchPolicy } from "@apollo/client";
import {
  Customer,
  CustomerCard_GetComponent,
  CustomerCard_GetQuery,
  CustomerCard_GetQueryVariables,
  SimpleCustomerCard_GetComponent,
  SimpleCustomerCard_GetQuery,
  SimpleCustomerCard_GetQueryVariables
} from "@graphql";
import { Body, Spinner } from "@components";
import CustomerCard, { CustomerCardProps } from "./CustomerCard";

type Props = CustomerCardProps & {
  id: string;
  fetchPolicy?: FetchPolicy;
  includeContactPersons?: boolean;
};

export function CustomerCardSubscriber(props: Props) {
  const { id, fetchPolicy, onDelete, ...rest } = props;

  const content = ({
    data,
    loading,
    error
  }: QueryResult<
    CustomerCard_GetQuery | SimpleCustomerCard_GetQuery,
    CustomerCard_GetQueryVariables | SimpleCustomerCard_GetQueryVariables
  >) => {
    if (loading) {
      return <Spinner />;
    }

    if (error) {
      return <Body color="error">{error as any}</Body>;
    }

    return (
      <CustomerCard
        {...rest}
        onDelete={onDelete}
        data={data.customerById as Partial<Customer>}
        withCallLists={true}
      />
    );
  };

  if (onDelete) {
    return (
      <CustomerCard_GetComponent variables={{ id }} fetchPolicy={fetchPolicy}>
        {content}
      </CustomerCard_GetComponent>
    );
  } else {
    return (
      <SimpleCustomerCard_GetComponent variables={{ id }} fetchPolicy={fetchPolicy}>
        {content}
      </SimpleCustomerCard_GetComponent>
    );
  }
}

CustomerCardSubscriber.defaultProps = {
  fetchPolicy: "cache-only"
};
